import {
  Default_getInstance2tu01uy631lll as Default_getInstance,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  isNumberiramasdbon0i as isNumber,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  Unit_instanceat14thlj150z as Unit_instance,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  VOID7hggqo3abtya as VOID,
  protoOf180f3jzyo7rfj as protoOf,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  to2cs3ny02qtbcb as to,
  printStackTrace18lnx7a39cni as printStackTrace,
  lazy2hsh8ze7j6ikd as lazy,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
} from './kotlin-kotlin-stdlib.mjs';
import {
  get_Deflate2a0lyute7oxjd as get_Deflate,
  uncompress3ofkd276wd0zn as uncompress,
} from './korlibs-compression-root-korlibs-compression.mjs';
import { getS32LE1pxm9wohin3g8 as getS32LE } from './korlibs-memory-root-korlibs-memory.mjs';
import { jsObjectr1r5ao37ef4f as jsObject } from './korlibs-platform-root-korlibs-platform.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class IWASMLib {}
function readBytes(pos, size) {
  throw NotImplementedError.be();
}
function writeBytes(pos, data) {
  throw NotImplementedError.be();
}
function invokeFunc(name, params) {
  throw NotImplementedError.be();
}
function invokeFuncInt(name, params) {
  var tmp = this.e3w(name, params.slice());
  var tmp0_safe_receiver = isNumber(tmp) ? tmp : null;
  var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : numberToInt(tmp0_safe_receiver);
  return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
}
function invokeFuncUnit(name, params) {
  this.e3w(name, params.slice());
}
function readInts(pos, size) {
  var bytes = this.c3w(pos, imul(size, 4));
  var tmp = 0;
  var tmp_0 = new Int32Array(size);
  while (tmp < size) {
    var tmp_1 = tmp;
    tmp_0[tmp_1] = getS32LE(bytes, imul(tmp_1, 4));
    tmp = tmp + 1 | 0;
  }
  return tmp_0;
}
function allocBytes(size) {
  return this.f3w('malloc', [size]);
}
function allocBytes_0(bytes) {
  // Inline function 'kotlin.also' call
  var this_0 = this.i3w(bytes.length);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.wasm.IWASMLib.allocBytes.<anonymous>' call
  this.d3w(this_0, bytes);
  return this_0;
}
function allocInts(size) {
  return this.i3w(imul(size, 4));
}
function freeBytes(ptrs) {
  var inductionVariable = 0;
  var last = ptrs.length;
  while (inductionVariable < last) {
    var ptr = ptrs[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    this.e3w('free', [ptr]);
  }
}
class WASMLib {
  constructor(content) {
    this.b3w_1 = new JSWASMLib(content);
  }
  c3w(pos, size) {
    return this.b3w_1.c3w(pos, size);
  }
  d3w(pos, data) {
    this.b3w_1.d3w(pos, data);
  }
  e3w(name, params) {
    return this.b3w_1.e3w(name, params);
  }
  f3w(name, params) {
    return this.b3w_1.f3w(name, params);
  }
  g3w(name, params) {
    this.b3w_1.g3w(name, params);
  }
  h3w(pos, size) {
    return this.b3w_1.h3w(pos, size);
  }
  i3w(size) {
    return this.b3w_1.i3w(size);
  }
  j3w(bytes) {
    return this.b3w_1.j3w(bytes);
  }
  k3w(size) {
    return this.b3w_1.k3w(size);
  }
  l3w(ptrs) {
    this.b3w_1.l3w(ptrs);
  }
  n6() {
    this.b3w_1.n6();
  }
}
class Base64DeflateWASMLib extends WASMLib {
  constructor(content) {
    super(uncompress(Default_getInstance().fo(content), get_Deflate()));
  }
}
class BaseWASMLib {
  constructor(content) {
    this.n3w_1 = content;
    this.o3w_1 = null;
  }
  m3w() {
    return this.n3w_1;
  }
  n6() {
  }
}
class JSWASMLib extends BaseWASMLib {
  constructor(content) {
    super(content);
    this.r3w_1 = null;
    var tmp = this;
    tmp.s3w_1 = lazy(JSWASMLib$mem$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.t3w_1 = lazy(JSWASMLib$u8$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.u3w_1 = lazy(JSWASMLib$dataView$delegate$lambda(this));
  }
  c3w(pos, size) {
    var out = new Int8Array(size);
    var u8 = _get_u8__ndcayw(this);
    var inductionVariable = 0;
    var last = out.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.get' call
        // Inline function 'kotlin.js.asDynamic' call
        out[n] = u8[pos + n | 0];
      }
       while (inductionVariable <= last);
    return out;
  }
  d3w(pos, data) {
    var inductionVariable = 0;
    var last = data.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.set' call
        // Inline function 'kotlin.js.asDynamic' call
        _get_u8__ndcayw(this)[pos + n | 0] = data[n];
      }
       while (inductionVariable <= last);
  }
  e3w(name, params) {
    var tmp0_elvis_lhs = _get_wasmExports__dbcjyi(this)[name];
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var message = "Can't find export '" + name + "'";
      throw IllegalStateException.h5(toString(message));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var export_0 = tmp;
    return export_0.apply(_get_wasmExports__dbcjyi(this), params);
  }
  n6() {
    super.n6();
  }
}
//endregion
function _get_wasmExports__dbcjyi($this) {
  if ($this.r3w_1 == null) {
    var tmp = $this;
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_0;
    try {
      var module_0 = new WebAssembly.Module(ensureNotNull($this.m3w()));
      var dummyFunc = JSWASMLib$_get_wasmExports_$lambda_zfsn0h;
      var imports = jsObject([to('env', jsObject([to('abort', dummyFunc), to('emscripten_notify_memory_growth', dummyFunc)])), to('wasi_snapshot_preview1', jsObject([to('proc_exit', dummyFunc), to('fd_close', dummyFunc), to('fd_write', dummyFunc), to('fd_seek', dummyFunc)]))]);
      tmp_0 = (new WebAssembly.Instance(module_0, imports)).exports;
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.wasm.JSWASMLib.<get-wasmExports>.<anonymous>' call
    tmp.r3w_1 = tmp_0;
  }
  return $this.r3w_1;
}
function _get_mem__e6cqxo($this) {
  // Inline function 'kotlin.getValue' call
  var this_0 = $this.s3w_1;
  mem$factory();
  return this_0.s1();
}
function _get_u8__ndcayw($this) {
  // Inline function 'kotlin.getValue' call
  var this_0 = $this.t3w_1;
  u8$factory();
  return this_0.s1();
}
function JSWASMLib$_get_wasmExports_$lambda_zfsn0h() {
  console.log('proc_exit', arguments);
  return Unit_instance;
}
function JSWASMLib$mem$delegate$lambda(this$0) {
  return function () {
    return _get_wasmExports__dbcjyi(this$0).memory.buffer;
  };
}
function JSWASMLib$u8$delegate$lambda(this$0) {
  return function () {
    return new Uint8Array(_get_mem__e6cqxo(this$0));
  };
}
function JSWASMLib$dataView$delegate$lambda(this$0) {
  return function () {
    return new DataView(_get_mem__e6cqxo(this$0));
  };
}
function mem$factory() {
  return getPropertyCallableRef('mem', 1, KProperty1, function (receiver) {
    return _get_mem__e6cqxo(receiver);
  }, null);
}
function u8$factory() {
  return getPropertyCallableRef('u8', 1, KProperty1, function (receiver) {
    return _get_u8__ndcayw(receiver);
  }, null);
}
//region block: post-declaration
initMetadataForInterface(IWASMLib, 'IWASMLib', VOID, VOID, [AutoCloseable]);
initMetadataForClass(WASMLib, 'WASMLib', VOID, VOID, [IWASMLib]);
initMetadataForClass(Base64DeflateWASMLib, 'Base64DeflateWASMLib');
protoOf(BaseWASMLib).c3w = readBytes;
protoOf(BaseWASMLib).d3w = writeBytes;
protoOf(BaseWASMLib).e3w = invokeFunc;
protoOf(BaseWASMLib).f3w = invokeFuncInt;
protoOf(BaseWASMLib).g3w = invokeFuncUnit;
protoOf(BaseWASMLib).h3w = readInts;
protoOf(BaseWASMLib).i3w = allocBytes;
protoOf(BaseWASMLib).j3w = allocBytes_0;
protoOf(BaseWASMLib).k3w = allocInts;
protoOf(BaseWASMLib).l3w = freeBytes;
initMetadataForClass(BaseWASMLib, 'BaseWASMLib', VOID, VOID, [IWASMLib]);
initMetadataForClass(JSWASMLib, 'JSWASMLib', VOID, VOID, [IWASMLib, BaseWASMLib]);
//endregion
//region block: exports
export {
  Base64DeflateWASMLib as Base64DeflateWASMLib1nkue0zm1qc0o,
};
//endregion
